import React from "react"
import types from "prop-types"
import { AccessLevelSelect } from "shared/selects"
import activeBeforeInactive from "utils/activeBeforeInactive"
import SearchSelectedUser from "./SearchSelectedUser"

const SelectedUsers = ({
  users, removeUser, setUserAccessLevel = null, workflowData = [], selectLabel = "",
}) => {
  if (users.length === 0) {
    return <div className="ml-4">No Selected User</div>
  }

  users = users.sort(activeBeforeInactive)

  const selectedAccessLevel = (userId) => workflowData.find((user) => user.id === userId).access_level

  return (
    users.map((user) => (
      <SearchSelectedUser
        key={user.id}
        user={user}
        deselect={() => removeUser(user.id)}
      >
        {
          setUserAccessLevel && !!workflowData.length && (
            <AccessLevelSelect
              onChange={(value) => setUserAccessLevel(value, user.id)}
              value={selectedAccessLevel(user.id)}
              selectLabel={selectLabel}
            />
          )
        }
      </SearchSelectedUser>
    ))
  )
}

SelectedUsers.propTypes = {
  users: types.arrayOf(types.object).isRequired,
  removeUser: types.func.isRequired,
  setUserAccessLevel: types.func,
  workflowData: types.arrayOf(types.object),
  selectLabel: types.string,
}

export default SelectedUsers
